export default __webpack_public_path__ + "img/magnify.b97096af.png";